import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckOutlined } from "@ant-design/icons";
import { Empty, List, App, Tag } from "antd";
import { observer } from "mobx-react";
import { useCallback } from "react";
import { useStores } from "../../../../store";
import { __ } from "../../../../utils";
/**
 * List all available menus and allow to add the legal links via button.
 */ const ShortCodeMenuList = observer(()=>{
    const { message } = App.useApp();
    const { optionStore } = useStores();
    const { navMenus, busyCountryBypassUpdate, others: { adminUrl } } = optionStore;
    const handleAdd = useCallback(async (id)=>{
        try {
            await optionStore.addLinksToNavigationMenu(id);
            message.success(__("Successfully added the links to your menu!"));
        } catch (e) {
            message.error(e.responseJSON.message);
        }
    }, []);
    return /*#__PURE__*/ _jsx(List, {
        loading: busyCountryBypassUpdate,
        itemLayout: "horizontal",
        dataSource: navMenus,
        size: "small",
        locale: {
            emptyText: /*#__PURE__*/ _jsx(Empty, {
                description: __("No WordPress menu created yet."),
                children: /*#__PURE__*/ _jsx("a", {
                    href: `${adminUrl}nav-menus.php`,
                    className: "button button-primary",
                    children: __("Create menu")
                })
            })
        },
        renderItem: (row)=>{
            const { id, applied, edit_url, languages, name } = row;
            return /*#__PURE__*/ _jsx(List.Item, {
                actions: [
                    applied ? /*#__PURE__*/ _jsxs("a", {
                        children: [
                            /*#__PURE__*/ _jsx(CheckOutlined, {
                                style: {
                                    color: "#52c41a"
                                }
                            }),
                            "\xa0",
                            __("Already added")
                        ]
                    }, "apply") : /*#__PURE__*/ _jsx("a", {
                        onClick: ()=>handleAdd(id),
                        children: __("Add all legal links")
                    }, "applied"),
                    /*#__PURE__*/ _jsx("a", {
                        target: "_blank",
                        href: edit_url,
                        rel: "noreferrer",
                        children: __("Edit manually")
                    }, "edit-manually")
                ],
                children: /*#__PURE__*/ _jsx(List.Item.Meta, {
                    title: /*#__PURE__*/ _jsxs("span", {
                        children: [
                            name,
                            " ",
                            languages.length > 0 && /*#__PURE__*/ _jsx(Tag, {
                                children: languages[0].language
                            })
                        ]
                    }),
                    description: row.type === "legacy_nav" && Object.values(row.locations).join(", ")
                })
            });
        }
    });
});
export { ShortCodeMenuList };
